import Vue from 'vue'
import Vuex from 'vuex'
import Account from './modules/Account'
import Layout from './modules/Layout'
import PageStatus from './modules/PageStatus'
Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    account: Account,
    layout: Layout,
    pageStatus: PageStatus
  }
})
